"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _AuthorInfo = _interopRequireDefault(require("./AuthorInfo"));

var _MultiDropdown = _interopRequireDefault(require("@insided/shared/uikit/MultiDropdown"));

var TopicHeader = function TopicHeader(_ref) {
  var author = _ref.author,
      timestamp = _ref.timestamp,
      _ref$isBestAnswer = _ref.isBestAnswer,
      isBestAnswer = _ref$isBestAnswer === void 0 ? false : _ref$isBestAnswer,
      isUserLoggedIn = _ref.isUserLoggedIn,
      menuItems = _ref.menuItems,
      _ref$showAuthorPill = _ref.showAuthorPill,
      showAuthorPill = _ref$showAuthorPill === void 0 ? false : _ref$showAuthorPill,
      _ref$isReplyHighlight = _ref.isReplyHighlighted,
      isReplyHighlighted = _ref$isReplyHighlight === void 0 ? false : _ref$isReplyHighlight,
      _ref$isReplyTrashed = _ref.isReplyTrashed,
      isReplyTrashed = _ref$isReplyTrashed === void 0 ? false : _ref$isReplyTrashed,
      _ref$isReplySpam = _ref.isReplySpam,
      isReplySpam = _ref$isReplySpam === void 0 ? false : _ref$isReplySpam,
      _ref$isReplyReported = _ref.isReplyReported,
      isReplyReported = _ref$isReplyReported === void 0 ? false : _ref$isReplyReported,
      _ref$isReplyPending = _ref.isReplyPending,
      isReplyPending = _ref$isReplyPending === void 0 ? false : _ref$isReplyPending,
      _ref$isNew = _ref.isNew,
      isNew = _ref$isNew === void 0 ? false : _ref$isNew,
      _ref$isReplyPinned = _ref.isReplyPinned,
      isReplyPinned = _ref$isReplyPinned === void 0 ? false : _ref$isReplyPinned,
      _ref$displayPostStatu = _ref.displayPostStatusPill,
      displayPostStatusPill = _ref$displayPostStatu === void 0 ? false : _ref$displayPostStatu,
      _ref$actionsToDisplay = _ref.actionsToDisplay,
      actionsToDisplay = _ref$actionsToDisplay === void 0 ? [] : _ref$actionsToDisplay,
      _ref$isHovered = _ref.isHovered,
      isHovered = _ref$isHovered === void 0 ? false : _ref$isHovered,
      _ref$useControlTheme = _ref.useControlTheme,
      useControlTheme = _ref$useControlTheme === void 0 ? false : _ref$useControlTheme;
  return (0, _preact.h)("div", {
    className: "topic-header"
  }, (0, _preact.h)("div", {
    className: "topic-header__author-info"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--responsive",
    showRank: true,
    width: 40,
    height: 40
  }), (0, _preact.h)(_AuthorInfo.default, {
    author: author,
    timestamp: timestamp,
    displayAuthor: showAuthorPill && !!author.id,
    isBestAnswer: isBestAnswer,
    displayPostStatusPill: displayPostStatusPill,
    isReplyHighlighted: isReplyHighlighted,
    isReplyTrashed: isReplyTrashed,
    isReplySpam: isReplySpam,
    isReplyPending: isReplyPending,
    isNew: isNew,
    isReplyPinned: isReplyPinned,
    isReplyReported: isReplyReported
  })), isUserLoggedIn && (0, _preact.h)("div", {
    className: "topic-header__actions-wrapper"
  }, (0, _preact.h)(_MultiDropdown.default, {
    actionsToDisplay: actionsToDisplay,
    menuOptions: menuItems,
    isHovered: isHovered,
    useControlTheme: useControlTheme
  })));
};

var _default = TopicHeader;
exports.default = _default;